<template>
  <div>
    <h5 v-if="!isEmpty(loop)">{{loop.description}}</h5>
    <div v-show="stepOptions">
      <b-form-group >
        <b-form-radio-group
          v-model="workstation"
          :options="stepOptions"
          button-variant="outline-primary"
          size="md"
          text-field="name"
          value-field="name"
          name="radio-btn-outline"
          buttons
          @change="workstation"
        ></b-form-radio-group>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import server from '../../api/server.vue'
import { bus } from '../../core/utils/bus.js'
import { Steps } from '../../core/services/steps.js'


export default {
  name: 'SelectWorkstation',
  props: ['loop'],
  data: function () {
    return {
      selectedWorkstation: null,
      workstation: '',
      stepOptions: [],
    }
  },
  watch: {
    loop (newValue, oldValue) {
      this.selectLoop (newValue)
    },
    workstation(newWorkstation) {
      localStorage.workstation = newWorkstation
      this.selectedWorkstation = newWorkstation
      this.save()
    }
  },
  methods: {
    isEmpty (value) {
      return _.isEmpty(value)
    },
    save () {
      bus.currentStep = Steps[this.selectedWorkstation]
      // window.localStorage.setItem('WORKSTATION', this.selectedWorkstation.name)
    },
    selectLoop (loop) {
      if(_.isEmpty(loop)) {
        return
      }
      server.getWorkstations(loop.name).then((result) => {
        this.stepOptions = result.data
        this.getWorkstation()
      })
    },
    getWorkstation () {
      this.selectedWorkstation = window.localStorage.getItem('WORKSTATION')
    },
  },
  mounted () {
    this.selectLoop(this.loop)
    if(localStorage.workstation) this.workstation = localStorage.workstation
   },
}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/kanban/SelectWorkstation.vue